// extracted by mini-css-extract-plugin
export default {"wrap":"PolicyContainer_wrap__9Sah0","pageHeader":"PolicyContainer_pageHeader__MKUAT","pageGuide":"PolicyContainer_pageGuide__8aJta"};